import { ActionBase } from '../../../core/store/action/ActionBase';

export const ACTIVATE_DRAFT_BROADCAST_MESSAGE_ACTION = '[Configuration] Messages Activate Draft Broadcast Message Action';

export class ActivateDraftBroadcastMessageAction implements ActionBase {
  readonly identifier = new Date().getTime().toString();
  readonly type = ACTIVATE_DRAFT_BROADCAST_MESSAGE_ACTION;
}



// WEBPACK FOOTER //
// ./src/app/messages/store/actions/ActivateDraftBroadcastMessageAction.ts